import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=fe2f5898&scoped=true"
import script from "./message-center.vue?vue&type=script&lang=ts"
export * from "./message-center.vue?vue&type=script&lang=ts"
import style0 from "./message-center.vue?vue&type=style&index=0&id=fe2f5898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2f5898",
  null
  
)

export default component.exports